import React from 'react';
import { Box, Type } from '@nerdwallet/currency';

var ReviewedAtInfo = function ReviewedAtInfo(_ref) {
  var reviewedAtDate = _ref.reviewedAtDate,
      periodConsideredDate = _ref.periodConsideredDate;
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Type, null, reviewedAtDate)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Type, null, periodConsideredDate)));
};

export default ReviewedAtInfo;